import { BaseApiClient } from "./BaseApiClient";
export const SEARCH_ENDPOINT = "/search?query={0}";
/**
 * SearchApiClient - client for looking for events and leagues BFF endpoints
 * @export
 * @class SearchApiClient
 * @extends {BaseApiClient}
 */
export class SearchApiClient extends BaseApiClient {
    /**
     * Search events and leagues by name from BFF
     * @param {query} string
     * @param {sportIds}
     * @throws {RequiredError}
     * @memberof SearchApiClient
     */
    search(query, sportIds) {
        let fetchOptions = {
            fetchOptOverride: {
                method: "GET"
            }
        };
        const querySportIds = sportIds ? sportIds.map(x => `&sportIds=${x}`).join("") : "";
        return this.executeRequest(SEARCH_ENDPOINT.format(query) + querySportIds, fetchOptions);
    }
}
//# sourceMappingURL=SearchApiClient.js.map